export default __webpack_public_path__ + "static/media/228.f5b1bc35.jpg";